<div class="agpr-chartBlock-wrapper">
    @if (isExporting) {
        <div class="agpr-chartBlock-exporting" [agprLoading]="isExporting"></div>
    }
    <div
        [id]="id"
        class='agpr-block agpr-chartBlock agpr-contextMenu-parent'
        [ngClass]="{
            'agpr-block--cannot-move': !block.canMove,
            'agpr-chartBlock--preview': preview,
            'agpr-chartBlock--exporting': exporting
        }"
        role="group"
        [attr.aria-label]="displayElement?.title + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
        tabindex="0"
    >
        @if (!preview) {
            <div
                class="agpr-block-dragHandle"
                role="button"
                tabindex="0"
                [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
                (keydown)="dragKeydown($event)"
            >
                <span class="fa-kit fa-agpr-drag-drop"></span>
            </div>
            <div #exportMenu>
                <ul
                    class="agpr-contextMenu top right"
                    role="menu"
                    [attr.aria-describedby]="id + '_errors' + ' ' + id + '_dataSource_error'"
                >
                    <li
                        role="menuitem"
                        class="agpr-contextMenu-menuItem"
                    >
                        <agpr-button
                            [id]="`${id}_edit`"
                            icon="fa-regular fa-duotone fa-pen"
                            tooltip="Reports.chartSetupDialog.editHeading"
                            tooltipPosition="top"
                            (click)="onAction('edit')"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                    </li>
                    <li
                        role="menuitem"
                        class="agpr-contextMenu-menuItem"
                    >
                        <agpr-button
                            [id]="`${id}_duplicate`"
                            icon="fa-regular fa-duotone fa-layer-plus"
                            tooltip="Reports.chartSetupDialog.duplicate"
                            tooltipPosition="top"
                            (click)="onAction('duplicate')"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                    </li>
                    <li
                        role="menuitem"
                        class="agpr-contextMenu-menuItem"
                    >
                        <agpr-chart-export-menu
                            [id]="`${id}_export`"
                            class="agpr-chartBlock-reportExportIcon"
                            [supportedFormats]="[ 'png', 'jpg', 'svg', 'csv', 'json', 'print' ]"
                            [tooltip]="'Reports.chartSetupDialog.exportHeading'"
                            tooltipPosition="top"
                            iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                            (exportMenuClicked)="chartExport($event)"
                        ></agpr-chart-export-menu>
                    </li>
                    <li
                        role="menuitem"
                        class="agpr-contextMenu-menuItem"
                    >
                        <agpr-button
                            [id]="`${id}_delete`"
                            icon="fa-regular fa-duotone fa-trash-can"
                            tooltip="Reports.chartSetupDialog.deleteChart"
                            tooltipPosition="top"
                            (click)="onAction('delete')"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                    </li>
                </ul>
            </div>
        }
        <div class="agpr-block-content">
            @if (preview && series && displayElement.topMentionsSortField !== topMentionsSortFields.custom) {
                <div class="agpr-chartBlock-watermark">
                    {{ 'Reports.chart.sampleData' | localize }}
                </div>
            }

            <div class="agpr-chartBlockMetadata">
                @if (displayElement?.chartHeaderSettings) {
                    @if (displayElement.chartHeaderSettings.title) {
                        <div class="agpr-chartBlockMetadata-title">
                            <label [id]="`${id}_title`"> {{ displayElement.title }} </label>
                        </div>
                    }
                    @if ((displayElement.chartHeaderSettings.dateRange || displayElement.chartHeaderSettings.sourceLink)
                        && displayElement.topMentionsSortField !== topMentionsSortFields.custom) {
                        <div class="agpr-chartBlockMetadata-subtitleGroup">
                            @if (displayElement?.chartHeaderSettings?.dateRange) {
                                <div
                                    class="agpr-chartBlockMetadata-dateRange"
                                    [agprTooltip]="displayElement.dateRangeLabel"
                                    tooltipPosition="bottom"
                                >
                                    {{ displayElement?.dateRangeLabel }}
                                </div>
                            }
                            @if (displayElement.chartHeaderSettings.sourceLink) {
                                <a
                                    [id]="`${id}_source`"
                                    class="agpr-chartBlockMetadata-source agpr-chartBlockMetadata-sourceLink"
                                    [ngClass]="{'noDate': !displayElement?.chartHeaderSettings?.dateRange}"
                                    target="_blank"
                                    [routerLink]="sourceRouterLink"
                                    [queryParams]="sourceRouterLinkQueryParams"
                                    [pTooltip]="series && series[0] ? series[0].label : ''"
                                    tooltipPosition="bottom"
                                    [attr.tabindex]="(series && series[0] && series[0].label) ? '0' : '-1'"
                                >
                                    {{ series && series[0] ? series[0].label : '' }}
                                </a>
                            }
                        </div>
                    }
                }
            </div>

            <div
                class="agpr-topMentionsChart-container"
                [ngClass]="{'noHeader': noHeader}"
            >
                @if (series) {
                    <agpr-scroll-panel>
                        <agpr-top-mentions-chart
                            [displayElement]="displayElement"
                            [sortField]="displayElement?.topMentionsSortField"
                            (dataChange)="cdr.detectChanges()"
                        ></agpr-top-mentions-chart>
                    </agpr-scroll-panel>
                } @else {
                    @if (preview) {
                        <agpr-message
                            class="agpr-topMentionsChart-noContentMessage"
                            [id]="id + '_dataSource_error'"
                            [severity]="messageSeverities.info"
                        >
                            {{ 'Reports.chart.noDataSource' | localize }}
                        </agpr-message>
                    } @else {
                        <agpr-message
                            class="agpr-topMentionsChart-noContentMessage"
                            [id]="id + '_dataSource_error'"
                            [severity]="messageSeverities.error"
                        >
                            {{ 'Reports.error.folderRemoved' | localize }}
                        </agpr-message>
                    }
                }
            </div>
        </div>
        <button
            class="gridster-item-resize gridster-item-resize--right"
            (keydown)="resizeKeydown($event)"
            [attr.aria-label]="'Dashboard.chart.resizeChart'"
        >
            <span
                class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
                role="img"
            ></span>
        </button>
        <div class="agpr-block-hoverBorder"></div>
    </div>
</div>
@if (block.errors?.length > 0) {
    <ul
        class="agpr-blockError"
        [id]="`${id}_errors`"
    >
        @for (error of block.errors; track error; let i = $index) {
            <li [id]="`${id}_errors_${i}`">
                <agpr-form-message>
                    {{ error | localize }}
                </agpr-form-message>
            </li>
        }
    </ul>
}
